import React from 'react';

import Chip from '@material-ui/core/Chip';

// AI review reasons as text with their cited sources as link chips; shared by the AI panel and the
// verdicts under the form fields.
export const stripOpenAiTracking = (text: string) =>
  text
    .replace(/\?utm_source=openai&/g, '?')
    .replace(/&utm_source=openai&/g, '&')
    .replace(/[?&]utm_source=openai(?=$|[#)\]}\s.,;])/g, '');

const SOURCE_CITATION_PATTERN = /\(\[[^\]\r\n]+\]\(([^)\s\r\n]+)\)\)/g;

export const renderReasonWithSourceChips = (reason: string, sourceChipClassName: string) => {
  const sanitizedReason = stripOpenAiTracking(reason);
  const content: React.ReactNode[] = [];
  let previousIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = SOURCE_CITATION_PATTERN.exec(sanitizedReason)) !== null) {
    const citation = match[0];
    const sourceUrl = match[1];
    let parsedUrl: URL;

    try {
      parsedUrl = new URL(sourceUrl);
    } catch {
      continue;
    }

    if (parsedUrl.protocol !== 'https:') continue;

    content.push(sanitizedReason.slice(previousIndex, match.index));
    content.push(
      <Chip
        key={`${match.index}-${sourceUrl}`}
        className={sourceChipClassName}
        component="a"
        clickable
        href={sourceUrl}
        target="_blank"
        rel="noopener noreferrer"
        title={sourceUrl}
        label={parsedUrl.hostname}
        size="small"
        variant="outlined"
      />
    );
    previousIndex = match.index + citation.length;
  }

  content.push(sanitizedReason.slice(previousIndex));
  return content;
};

